// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jH-z","twoColumnImage":"kH-z"};